import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { PaymentMethodsUI } from '@grandvisionhq/payments';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/state';
import '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../StepShipping/selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/utils';
import '../mappers/errors-mapping.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/api-client';
import '@grandvisionhq/auth';
import '../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { Footer } from '../modules/Footer/Footer.js';
import '@grandvisionhq/bloomreach';

const StepPayment = ({ labels , onNextClick , onPrevClick , selectedPaymentMethod , onPaymentMethodSelected , onHandlePayment , cartId , addAdditionalPaymentCosts , qrCodeForm , orderInProgress , selectedDonation , onDonationSelected , totalPrice ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--payment"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "checkout-step__title"
    }, labels.paymentMethodTitle), labels.paymentMethodSecure && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__subtitle"
    }, labels.paymentMethodSecure), /*#__PURE__*/ React.createElement(PaymentMethodsUI, {
        cartId: cartId,
        onPaymentMethodSelected: onPaymentMethodSelected,
        selectedDonation: selectedDonation,
        onDonationSelected: onDonationSelected,
        paymentMethodName: selectedPaymentMethod !== null && selectedPaymentMethod !== void 0 ? selectedPaymentMethod : '',
        onHandlePayment: onHandlePayment,
        addAdditionalPaymentCosts: addAdditionalPaymentCosts,
        qrCodeForm: qrCodeForm,
        orderInProgress: orderInProgress,
        totalPrice: totalPrice
    }), /*#__PURE__*/ React.createElement(Footer, {
        selectedPaymentMethod: selectedPaymentMethod,
        nextStepHidden: true,
        stepName: StepNames.Payment,
        nextStepDisabled: false,
        onPrevStep: onPrevClick,
        onNextStep: onNextClick
    }))
;

export { StepPayment };
//# sourceMappingURL=StepPayment.js.map
